export default ".inner-container {\n  width: 500px;\n  min-height: 500px;\n}";